function parseColor(colorStr) {
    if (!colorStr || typeof colorStr !== "string") return null;
    const hexMatch = colorStr.match(/^#?([a-f\d]{3}|[a-f\d]{6})$/i);
    if (hexMatch) {
        const hex = hexMatch[1];
        return {
            r: parseInt(hex.length === 3 ? hex[0] + hex[0] : hex.substr(0, 2), 16),
            g: parseInt(hex.length === 3 ? hex[1] + hex[1] : hex.substr(2, 2), 16),
            b: parseInt(hex.length === 3 ? hex[2] + hex[2] : hex.substr(4, 2), 16),
        };
    }
    const rgbMatch = colorStr.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (rgbMatch) {
        return {
            r: parseInt(rgbMatch[1], 10),
            g: parseInt(rgbMatch[2], 10),
            b: parseInt(rgbMatch[3], 10),
        };
    }
    return null;
}

function getLuminance(r, g, b) {
    const [rr, gg, bb] = [r / 255, g / 255, b / 255].map((c) =>
        c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)
    );
    return 0.2126 * rr + 0.7152 * gg + 0.0722 * bb;
}

/**
 * Retorna cor de texto (#010101 ou #FFFFFF) com contraste adequado para WCAG 2.1 AA.
 */
export function getContrastTextColor(backgroundColor) {
    const rgb = parseColor(backgroundColor);
    if (!rgb) return "#010101";
    const luminance = getLuminance(rgb.r, rgb.g, rgb.b);
    return luminance > 0.18 ? "#010101" : "#FFFFFF";
}

/**
 * Retorna { backgroundColor, color } para badges, escurecendo o fundo quando
 * necessário para garantir contraste WCAG 4,5:1. Texto em 12px bold (grande).
 */
export function getAccessibleBadgeColors(backgroundColor) {
    const rgb = parseColor(backgroundColor);
    if (!rgb) return { backgroundColor: "#666666", color: "#FFFFFF" };

    let r = rgb.r, g = rgb.g, b = rgb.b;
    let luminance = getLuminance(r, g, b);

    // Zona problemática (luminosidade > 0,2): escurecer para branco ter contraste ≥ 4,5:1
    if (luminance > 0.2) {
        const factor = Math.max(0.35, 0.18 / luminance);
        r = Math.round(r * factor);
        g = Math.round(g * factor);
        b = Math.round(b * factor);
        return { backgroundColor: `rgb(${r}, ${g}, ${b})`, color: "#FFFFFF" };
    }

    return { backgroundColor: backgroundColor, color: getContrastTextColor(backgroundColor) };
}
